export default __webpack_public_path__ + "static/media/General's Chestplate of the Eastern Sun.3d69fd08.jpg";